import { render, staticRenderFns } from "./CreditClass.vue?vue&type=template&id=8a5ac3b6"
import script from "./CreditClass.vue?vue&type=script&lang=js"
export * from "./CreditClass.vue?vue&type=script&lang=js"
import style0 from "./CreditClass.vue?vue&type=style&index=0&id=8a5ac3b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports